// @ts-nocheck
import React, { useEffect, useState } from 'react';
import CropperComponent from './CropperComponent';
import { AddCoverPhoto } from './AddCoverPhoto';
import { AddFreePhotos } from './AddFreePhotos';
import { AddPostDescription } from './AddPostDescription';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { clear_Image_Post_State, set_No_Of_Images, set_Original_Selected_Images, setView } from '../../redux/imageUploadSlice';

const ImageInput = () => {
  const dispatch = useDispatch();
  const [selectedImages, setSelectedImages] = useState([]);
  const [croppedImages, setCroppedImages] = useState([]);

  const currentView = useSelector((state: RootState) => state.imagePost.view);

  const onCropComplete = (croppedImages) => {
    setCroppedImages(croppedImages);
  };
  
  const component = {
    NONE:null,
    CAROUSEL_VIEW:<CropperComponent onCropComplete={onCropComplete}/>,
    FREE_PHOTOS:<AddFreePhotos />,
    COVER_PHOTOS:<AddCoverPhoto />,
    POST_DETAILS:<AddPostDescription />
  }

  const onSelectFiles = (event) => {
    const totalImages = event.target.files.length;
    // no of selected pics
    dispatch(set_No_Of_Images(totalImages));
    if (event.target.files && totalImages > 0) {
      const fileArray = Array.from(event.target.files).map(file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsDataURL(file);
        });
      });

      Promise.all(fileArray)
        .then(results => {
          setSelectedImages(results)
          dispatch(setView('CAROUSEL_VIEW'))
          dispatch(set_Original_Selected_Images(results))
         
        })
        .catch(error => console.error('Error reading files: ', error));
    }
  };

  return (
    <div>
      {component[currentView]}
    </div>
  );
};

export default ImageInput;
 